import { waitSeconds } from "../utilitiesmodule";

export async function deleteGroup(group) {
	//Personalizzo la dialog da mostrare
	var dialogID = Math.floor(100000 + Math.random() * 900000).toString();
	var dialogTitle = this.$t("Delete Group");
	var dialogContent = this.$t('deleteConfirmation', { 0: group.name_group });

	let self = this;
	this.$root.$on(dialogID, async ok => {
		self.$root.$off(dialogID);
		if (!ok) {
			if (self.$router.path != "/groups") {
				self.$router.replace({ path: '/groups' });
			}
			return;
		}
		ok = await self.$api.deleteGroup(group.id_group);

		//Se la cancellazione del gruppo non va a buon fine, riporto l'URL a /groups
		if (!ok) {
			return;
		}
		await waitSeconds(0.1);
		//Se la cancellazione del gruppo va a buon fine, cancello il gruppo in session
		var groups = this.$session.getGroups();
		groups.splice(groups.findIndex(g => g.id_group == group.id_group), 1);
		self.$session.setGroups(groups);
		this.$root.$emit("refreshGroups")
	});

	//Avvio la richiesta che mi risponderà con un $emit
	this.$root.openYesNoDialog(dialogID, dialogTitle, dialogContent);
}

export function getPCListByGroup(group) {
	let pcMap = this.$session.getPCList().toMap("id");
	return group.ids_computers.map(id => pcMap[id]);
}

export function getAllGroupsWithIdPC(idPC) {
	return this.$session.getGroups().filter(g => g.ids_computers.includes(idPC));
}

export function getAllGroupsWithIdCustomer(id_customer) {
	return this.$session.getGroups().filter(g => g.id_customer == id_customer);
}